import React from 'react';
import PropTypes from 'prop-types';
import {ClipLoader} from 'react-spinners';
import cn from 'classnames';

import styles from './ClipSpinner.module.scss';
import {mainGreen} from 'styles/variables';

function ClipSpinner({className, width, height, color, ...props}) {
    return (
        <div className={cn(styles.spinnerContainer, className)} {...props}>
            <ClipLoader color={color} css={{width, height}} />
        </div>
    );
}

ClipSpinner.propTypes = {
    className: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    color: PropTypes.string,
};

ClipSpinner.defaultProps = {
    width: '1rem',
    height: '1rem',
    color: mainGreen,
};

export default React.memo(ClipSpinner);
